import * as React from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Padding } from "@mui/icons-material";
import Parse from "../../API/ParseServer";

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",

    // padding: "12px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "black",
    Padding: "3px",
  },
  borderBottom: "2px solid #dad9da",
  boxSizing: "inherit",
  // "& .MuiTabs-indicator": {
  //   backgroundColor: "#1890ff",
  // },
  "& .MuiTabs-scroller": {
    overflow: "scroll !important",
    "&::-webkit-scrollbar": {
      display: "none !important",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(24),
  marginRight: theme.spacing(1),
  color: "gray",
  "&.Mui-selected": {
    color: "black",
    boxShadow: "0 4px #0a0a0a",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "black",
    boxShadow: "0 4px #0a0a0a",
  },
}));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CustomizedTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [exhibitions, setExhibitions] = React.useState<any[]>([]);
  const [events, setEvents] = React.useState<any[]>([]);
  const [artWalls, setArtWalls] = React.useState<any[]>([]);
  const [artFairs, setArtFairs] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  function truncate(str: string, maxLength: number) {
    return str.length > maxLength
      ? str.substring(0, maxLength - 3) + "..."
      : str;
  }
  React.useEffect(() => {
    const fetchExhibitions = async () => {
      const query = new Parse.Query("Artwall_Exhibition");
      query.notEqualTo("type", "ArtWall");

      try {
        const results = await query.find();
        setExhibitions(results);
        console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchExhibitions();
    const fetchArtWalls = async () => {
      const query = new Parse.Query("Artwall_Exhibition");
      query.equalTo("type", "ArtWall");
      try {
        const results = await query.find();
        setArtWalls(results);
        console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtWalls();
    const fetchEvents = async () => {
      const query = new Parse.Query("Artfair_Festival");
      query.notEqualTo("type", "ArtFair");
      try {
        const results = await query.find();
        setEvents(results);
        console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
    const fetchArtFairs = async () => {
      const query = new Parse.Query("Artfair_Festival");
      query.equalTo("type", "ArtFair");

      try {
        const results = await query.find();
        setArtFairs(results);
        console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtFairs();
  }, []);
  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
          sx={{ overflow: "scroll" }}
        >
          <StyledTab label="Art Wall" {...a11yProps(0)} />
          <StyledTab label="Art Fairs" {...a11yProps(1)} />
          <StyledTab label="Exhibitions" {...a11yProps(2)} />
          <StyledTab label="Festivals & Events" {...a11yProps(3)} />
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {artWalls.length ? (
          <Grid container spacing={{ xs: 3, md: 8 }}>
            {artWalls &&
              artWalls.map((exhibition: any) => (
                <Grid item xs={12} sm={6} md={4} sx={{}}>
                  <Link to={`/gallery/exhibition/${exhibition.id}`}>
                    {exhibition.get("thumbnail") ? (
                      <img
                        src={exhibition.get("thumbnail").url()}
                        alt={exhibition.get("title")}
                        style={{ width: "100%", aspectRatio: 1 }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: 1,
                          backgroundColor: "gray",
                          cursor: "pointer",
                        }}
                      ></Box>
                    )}
                  </Link>
                  <Typography variant="h6" component="h2">
                    {truncate(exhibition.get("title"), 30)}
                  </Typography>
                  <Typography
                    // component="h2"
                    variant="subtitle2"
                    sx={{ color: "#863a1d" }}
                  >
                    {exhibition.get("startDate").toDateString()} -{" "}
                    {exhibition.get("endDate").toDateString()}
                  </Typography>
                  <Typography sx={{ marginTop: "1rem" }}>
                    {exhibition.get("description")}
                  </Typography>
                </Grid>
              ))}
          </Grid>
        ) : (
          <Typography>No Exhibtion!</Typography>
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {artFairs.length ? (
          <Grid container spacing={{ xs: 3, md: 8 }}>
            {artFairs &&
              artFairs.map((event: any) => (
                <Grid item xs={12} sm={6} md={4} sx={{}}>
                  <Link to={`/gallery/event/${event.id}`}>
                    {event.get("thumbnail") ? (
                      <img
                        src={event.get("thumbnail").url()}
                        alt={event.get("title")}
                        style={{ width: "100%", aspectRatio: 1 }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: 1,
                          backgroundColor: "gray",
                          cursor: "pointer",
                        }}
                      ></Box>
                    )}
                  </Link>
                  <Typography variant="h6" component="h2">
                    {truncate(event.get("title"), 30)}
                  </Typography>
                  <Typography
                    component="h2"
                    variant="subtitle1"
                    sx={{ color: "#863a1d" }}
                  >
                    {event.get("startDate").toDateString()} -{" "}
                    {event.get("endDate").toDateString()}
                  </Typography>
                  <Typography sx={{ marginTop: "1rem" }}>
                    {event.get("description")}
                  </Typography>
                </Grid>
              ))}
          </Grid>
        ) : (
          <Typography>No Events!</Typography>
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        {exhibitions.length ? (
          <Grid container spacing={{ xs: 3, md: 8 }}>
            {exhibitions &&
              exhibitions.map((exhibition: any) => (
                <Grid item xs={12} sm={6} md={4} sx={{}}>
                  <Link to={`/gallery/exhibition/${exhibition.id}`}>
                    {exhibition.get("thumbnail") ? (
                      <img
                        src={exhibition.get("thumbnail").url()}
                        alt={exhibition.get("title")}
                        style={{ width: "100%", aspectRatio: 1 }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: 1,
                          backgroundColor: "gray",
                          cursor: "pointer",
                        }}
                      ></Box>
                    )}
                  </Link>
                  <Typography variant="h6" component="h2">
                    {truncate(exhibition.get("title"), 30)}
                  </Typography>
                  <Typography
                    component="h2"
                    variant="subtitle1"
                    sx={{ color: "#863a1d" }}
                  >
                    {exhibition.get("startDate").toDateString()} -{" "}
                    {exhibition.get("endDate").toDateString()}
                  </Typography>
                  <Typography sx={{ marginTop: "1rem" }}>
                    {exhibition.get("description")}
                  </Typography>
                </Grid>
              ))}
          </Grid>
        ) : (
          <Typography>No Exhibtion!</Typography>
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        {events.length ? (
          <Grid container spacing={{ xs: 3, md: 8 }}>
            {events &&
              events.map((event: any) => (
                <Grid item xs={12} sm={6} md={4} sx={{}}>
                  <Link to={`/gallery/event/${event.id}`}>
                    {event.get("thumbnail") ? (
                      <img
                        src={event.get("thumbnail").url()}
                        alt={event.get("title")}
                        style={{ width: "100%", aspectRatio: 1 }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: 1,
                          backgroundColor: "gray",
                          cursor: "pointer",
                        }}
                      ></Box>
                    )}
                  </Link>
                  <Typography variant="h6" component="h2">
                    {truncate(event.get("title"), 30)}
                  </Typography>
                  <Typography
                    component="h2"
                    variant="subtitle1"
                    sx={{ color: "#863a1d" }}
                  >
                    {event.get("startDate").toDateString()} -{" "}
                    {event.get("endDate").toDateString()}
                  </Typography>
                  <Typography sx={{ marginTop: "1rem" }}>
                    {event.get("description")}
                  </Typography>
                </Grid>
              ))}
          </Grid>
        ) : (
          <Typography>No Events!</Typography>
        )}
      </CustomTabPanel>
    </Box>
  );
}
